/* NUBARELA — theme scripts */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Botón hero: baja hasta "Elige tu pack" ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-scroll-to]');
    if (!t) return;
    var target = $(t.dataset.scrollTo);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- Menú móvil ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (!t) return;
    var nav = $('[data-nav]');
    if (!nav) return;
    t.setAttribute('aria-expanded', nav.classList.toggle('is-open') ? 'true' : 'false');
  });

  /* ---------- Galería ---------- */
  function galInit() {
    var track = $('[data-gal-track]');
    if (!track) return;

    function setActive(i) {
      $$('[data-gal-dot]').forEach(function (d) { d.classList.toggle('is-on', +d.dataset.galDot === i); });
      $$('[data-gal-go]').forEach(function (d) { d.classList.toggle('is-active', +d.dataset.galGo === i); });
    }
    function goTo(i) {
      var slide = track.children[i];
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-gal-go], [data-gal-dot]');
      if (!b) return;
      goTo(+(b.dataset.galGo !== undefined ? b.dataset.galGo : b.dataset.galDot));
    });
    var tick;
    track.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(i);
      }, 90);
    }, { passive: true });
  }

  /* ---------- Variantes ---------- */
  function variantsInit() {
    var form = $('[data-product-form]');
    if (!form) return;
    var raw = $('[data-variant-json]', form);
    if (!raw) return;
    var variants;
    try { variants = JSON.parse(raw.textContent); } catch (e) { return; }

    var idInput = $('[data-variant-id]', form);
    var now = $('[data-price-now]');
    var was = $('[data-price-was]');
    var save = $('[data-price-save]');
    var btns = function () { return $$('[data-buy]'); };

    function selected() {
      return $$('[data-option-index]', form).filter(function (i) { return i.checked; })
        .sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; })
        .map(function (i) { return i.value; });
    }
    function update() {
      var opts = selected();
      var v = opts.length
        ? variants.find(function (x) { return x.options.length === opts.length && x.options.every(function (o, i) { return o === opts[i]; }); })
        : variants[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      form.dataset.unitPrice = v.price;
      if (now) now.textContent = window.Nubarela.money(v.price);
      var sp = $('[data-sticky-price]');
      if (sp) sp.textContent = window.Nubarela.money(v.price);
      if (was) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        was.hidden = !sale;
        if (sale) was.textContent = window.Nubarela.money(v.compare_at_price);
        if (save) {
          save.hidden = !sale;
          if (sale) save.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
        }
      }
      btns().forEach(function (b) { b.disabled = !v.available; });
    }
    /* La galería de arriba está agrupada en parejas de fotos por color: Verde(0-1), Morado(2-3), Azul marino(4-5) */
    var galColorIndex = { 'Verde': 0, 'Morado': 2, 'Azul marino': 4 };
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-index]')) return;
      update();
      var colorValue = e.target.value;
      if (galColorIndex.hasOwnProperty(colorValue)) {
        var dot = $('[data-gal-dot="' + galColorIndex[colorValue] + '"]');
        if (dot) dot.click();
      }
    });
    update();

    /* ---------- Elige tu pack: selecciona la variante real que corresponda ---------- */
    window.NubarelaFindVariantByValue = function (value) {
      if (!value) return null;
      return variants.find(function (v) {
        return v.options.indexOf(value) !== -1;
      }) || null;
    };
    /* Igual, pero exige que TODOS los valores dados (p. ej. Pack + Color) estén en la variante */
    window.NubarelaFindVariantByValues = function (values) {
      values = (values || []).filter(Boolean);
      if (!values.length) return null;
      return variants.find(function (v) {
        return values.every(function (val) { return v.options.indexOf(val) !== -1; });
      }) || null;
    };
  }

  /* ---------- Reseñas: ver más ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-revs-more]');
    if (!b) return;
    var section = b.closest('.section');
    var track = section ? $('[data-revs]', section) : null;
    if (!track) return;
    track.classList.add('is-expanded');
    b.hidden = true;
  });

  /* ---------- Miniaturas de color: cambian la foto grande del pack ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-pack-swatch]');
    if (!sw) return;
    var card = sw.closest('.pack');
    if (!card) return;
    $$('[data-pack-swatch]', card).forEach(function (b) { b.classList.toggle('is-active', b === sw); });
    var colorInput = $('[data-pack-color]', card);
    if (colorInput) colorInput.value = sw.dataset.colorValue;
    var img = $('[data-pack-mainimg]', card);
    if (img) {
      img.src = sw.dataset.imgLg;
      img.srcset = sw.dataset.imgSm + ' 640w, ' + sw.dataset.imgLg + ' 1100w';
    }
  });

  /* ---------- Tarjetas de pack: resaltar la elegida ---------- */
  function packCardsInit() {
    var cards = $$('.pack');
    if (!cards.length) return;
    function mark(value) {
      cards.forEach(function (card) {
        var radio = $('[data-pack-radio]', card);
        card.classList.toggle('is-selected', !!radio && radio.dataset.packVariantValue === value);
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-buy][data-pack-variant-value]');
      if (!btn) return;
      var card = btn.closest('.pack');
      if (card) { var r = $('[data-pack-radio]', card); if (r) r.checked = true; }
      mark(btn.dataset.packVariantValue);
    });
  }

  /* ---------- Añadir al carrito (todos los CTA) ---------- */
  var busy = false;
  var TIMEOUT_MS = 12000;

  /* Guarda el texto original del botón la primera vez que se pulsa,
     para poder restaurarlo siempre y que nunca se quede en "Añadiendo…". */
  function rememberLabel(btn) {
    if (btn.dataset.originalLabel) return;
    var l = $('[data-buy-label]', btn);
    btn.dataset.originalLabel = l ? l.textContent : btn.textContent;
  }

  function resetBuyBtn(btn) {
    if (!btn) return;
    btn.classList.remove('is-loading');
    var orig = btn.dataset.originalLabel;
    if (!orig) return;
    var l = $('[data-buy-label]', btn);
    if (l) l.textContent = orig; else btn.textContent = orig;
  }

  function clearPackError(btn) {
    var scope = btn.closest('.pack') || btn.parentElement;
    var box = scope ? $('[data-pack-error]', scope) : null;
    if (box && box.parentNode) box.parentNode.removeChild(box);
  }

  function showPackError(btn, msg) {
    clearPackError(btn);
    var box = document.createElement('p');
    box.setAttribute('data-pack-error', '');
    box.setAttribute('role', 'alert');
    box.style.cssText = 'margin:10px 0 0;font-size:13px;line-height:1.45;color:#a3402f;';
    box.textContent = msg;
    btn.insertAdjacentElement('afterend', box);
  }

  /* Al volver con el botón Atrás, el navegador puede restaurar la página tal
     y como estaba (bfcache): con el cerrojo puesto y el botón en "Añadiendo…".
     Esto lo suelta y devuelve los botones a su estado normal. */
  window.addEventListener('pageshow', function () {
    busy = false;
    $$('[data-buy]').forEach(resetBuyBtn);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-buy]');
    if (!btn) return;
    e.preventDefault();
    if (busy) return;

    var form = $('[data-product-form]');
    if (!form) return;
    var id = $('[data-variant-id]', form);
    var qtyEl = $('[data-qty-input]', form);
    if (!id) return;

    rememberLabel(btn);
    clearPackError(btn);

    var packValue = btn.dataset.packVariantValue;
    if (packValue) {
      var card = btn.closest('.pack');
      var colorSel = card ? $('[data-pack-color]', card) : null;
      var wanted = (colorSel && colorSel.value) ? [packValue, colorSel.value] : [packValue];
      var match = window.NubarelaFindVariantByValues
        ? window.NubarelaFindVariantByValues(wanted)
        : null;

      /* Si no hay variante real para esta combinación NO seguimos: antes se
         añadía la variante anterior, que es cobrar un pack que no eligió. */
      if (!match) {
        console.error('[Nubarela] No existe variante para', wanted, '— añadido cancelado.');
        showPackError(btn, 'No hemos podido preparar este pack. Recarga la página e inténtalo de nuevo.');
        return;
      }

      id.value = match.id;
      if (qtyEl) qtyEl.value = 1;
      form.dataset.unitPrice = match.price;
      var nowEl = $('[data-price-now]');
      var spEl = $('[data-sticky-price]');
      if (nowEl) nowEl.textContent = window.Nubarela.money(match.price);
      if (spEl) spEl.textContent = window.Nubarela.money(match.price);
    }

    var variantId = Number(id.value);
    if (!variantId) {
      console.error('[Nubarela] variant id vacío o inválido:', id.value);
      showPackError(btn, 'No hemos podido preparar este pack. Recarga la página e inténtalo de nuevo.');
      return;
    }

    busy = true;
    btn.classList.add('is-loading');
    var label = $('[data-buy-label]', btn);
    if (label) label.textContent = 'Añadiendo…'; else btn.textContent = 'Añadiendo…';

    /* Corta la petición si se queda colgada, en vez de esperar para siempre. */
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, TIMEOUT_MS);
    var navegando = false;

    var opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: Number(qtyEl && qtyEl.value || 1) }] })
    };
    if (ctrl) opts.signal = ctrl.signal;

    fetch('/cart/add.js', opts)
      .then(function (r) {
        return r.text().then(function (t) {
          var d = null;
          try { d = JSON.parse(t); } catch (err) { /* respuesta no-JSON */ }
          return { ok: r.ok, status: r.status, d: d, raw: t };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          var err = new Error((res.d && (res.d.description || res.d.message)) || ('HTTP ' + res.status));
          err.detalle = { status: res.status, cuerpo: res.d || res.raw };
          throw err;
        }
        navegando = true;
        window.location.href = '/cart';
      })
      .catch(function (err) {
        var abortado = err && err.name === 'AbortError';
        console.error('[Nubarela] Fallo al añadir a la cesta', {
          variantId: variantId,
          pack: packValue || '(CTA principal)',
          motivo: abortado ? ('timeout ' + TIMEOUT_MS + 'ms') : (err && err.message),
          detalle: err && err.detalle
        });
        showPackError(btn, abortado
          ? 'La conexión está tardando demasiado. Comprueba tu internet e inténtalo de nuevo.'
          : 'No se pudo añadir a la cesta. Inténtalo de nuevo en unos segundos.');
      })
      .finally(function () {
        clearTimeout(timer);
        /* Si ya vamos camino del carrito mantenemos el cerrojo puesto: así no
           se puede disparar un segundo AddToCart mientras navega. Al volver
           con Atrás, el listener de 'pageshow' lo suelta. */
        if (!navegando) {
          busy = false;
          resetBuyBtn(btn);
        }
      });
  });

  /* ---------- Barra fija móvil ---------- */
  function stickyInit() {
    var bar = $('[data-stickybar]');
    var cta = $('.pdp__cta');
    if (!bar || !cta) return;
    function check() {
      var past = cta.getBoundingClientRect().bottom < 0;
      var nearFoot = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 260);
      bar.hidden = !(past && !nearFoot);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  /* ---------- Vídeo diferido ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-video-play]');
    if (!b) return;
    var box = b.closest('[data-video]');
    if (!box) return;
    var id = box.dataset.embed, type = box.dataset.type;
    if (!id) return;
    var src = type === 'vimeo'
      ? 'https://player.vimeo.com/video/' + id + '?autoplay=1'
      : 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
    var f = document.createElement('iframe');
    f.src = src;
    f.title = 'Vídeo';
    f.loading = 'lazy';
    f.allow = 'autoplay; encrypted-media; picture-in-picture';
    f.allowFullscreen = true;
    box.innerHTML = '';
    box.appendChild(f);
  });

  document.addEventListener('DOMContentLoaded', function () {
    galInit();
    variantsInit();
    packCardsInit();
    stickyInit();
  });
})();
